<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { useStore } from 'vuex';

export default {
  name: 'resetPasswordMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const resetPasswordMutation = gql`
      mutation($password: String!, $passwordConfirmation: String!, $code: String!) {
        resetPassword(
          password: $password
          passwordConfirmation: $passwordConfirmation
          code: $code
        ) {
          jwt
          user {
            id
          }
        }
      }
      `;

    const { execute: resetPassword } = useMutation(resetPasswordMutation);
    store.commit('setStrapiExecutionHandler', { item: 'resetPassword', result: resetPassword });
  },
};
</script>
